import type {
  PublicWarningSettings,
  UpdatePublicWarningSettingsBody,
} from "@/lib/api/types";
import { overrideOr, toOverride, type WarningPageCopy } from "@/lib/warning-page-copy";

export interface PublicWarningPageSettings extends WarningPageCopy {
  enabled: boolean;
}

/** Resolves overrides over locale `defaults`; absent settings keep the page enabled. */
export function readPublicWarningPageSettings(
  settings: PublicWarningSettings | null | undefined,
  defaults: WarningPageCopy,
): PublicWarningPageSettings {
  return {
    enabled: settings?.enabled !== false,
    title: overrideOr(settings?.title_override, defaults.title),
    description: overrideOr(settings?.description_override, defaults.description),
    toolbarLabel: overrideOr(settings?.toolbar_label_override, defaults.toolbarLabel),
  };
}

/** Copy that is blank or equals the locale default is sent as `null` (no override). */
export function publicWarningSettingsUpdateBody(
  values: {
    enabled: boolean;
    title?: string;
    description?: string;
    toolbarLabel?: string;
  },
  defaults: WarningPageCopy,
): UpdatePublicWarningSettingsBody {
  return {
    enabled: values.enabled,
    title_override: toOverride(values.title, defaults.title),
    description_override: toOverride(values.description, defaults.description),
    toolbar_label_override: toOverride(values.toolbarLabel, defaults.toolbarLabel),
  };
}
